import React, {useEffect, useMemo, useState} from 'react';
import {connect} from 'react-redux';
import Config from '../../../Config';
import {buildUrlOpenPageSelfAndRestBlank} from 'app/utilities/StringHelpers/StringHelpers';
import PopUp from '../../Shared/Popup/PopUp';
import {sendCouponsSms} from './CouponComponentSlice';
import {innerPopupTypes,kosherOrAflaloStatusTypes,templateCodeTypes} from './CouponComponentEnums';
import InnerPopupComponent from './InnerPopupComponent';
import thumbUp from './images/thumbUp.svg';
import warningSign from './images/warningSign.svg';
import {getKosherOrAflaloStatus} from './CouponComponentSlice';
import {dwhResendCouponSuccessReport,dwhResendCouponErrorReport} from 'app/Components/Block/CouponHistory/Reports/dwhReports';
import Image from 'app/Components/Shared/Image/image';
import { isMobile } from 'react-device-detect';
import emptyCouponRightMobile from './images/mobileEmptyCouponRight.svg';
import emptyCouponRightDesktop from './images/desktopEmptyCouponRight.svg';
import emptyCouponLeftMobile from './images/mobileEmptyCouponLeft.svg';
import emptyCouponLeftDesktop from './images/desktopEmptyCouponLeft.svg';
import grayEmptyCouponRightMobile from './images/mobileGrayEmptyCouponRight.svg';
import grayEmptyCouponRightDesktop from './images/desktopGrayEmptyCouponRight.svg';
import grayEmptyCouponLeftMobile from './images/mobileGrayEmptyCouponLeft.svg';
import grayEmptyCouponLeftDesktop from './images/desktopGrayEmptyCouponLeft.svg';
const CouponComponentMain = ({
  coupon:{
    couponNumber,
    clientName,
    couponDescription,
    clientPhone,
    couponExpiryDate,
    smsText,
    imageUrl,
    logoUrl,
    termsLink,
    couponType,
    isUsed,
    primaryContactPhone,
    useDate
  },
  sendCouponsSms,
  getKosherOrAflaloStatus,
  loginData
}) => {
  const [innerPopupType, setInnerPopupType] = useState(null);
  const [showPopUp, setShowPopUp] = useState(false);
  const [smsDestinationNumber, setSmsDestinationNumber] = useState(null);
  const isClientNameTooLong = useMemo(() => {return clientName && clientName.length > 13;}, []);

  function isCouponValid(date){
    const [day, month, year] = date.split('.').map(Number);
    const expiryDate = new Date(year < 100 ? year + 2000 : year, month - 1, day);
    return expiryDate >= new Date().setHours(0, 0, 0, 0);
  };

  function validateMobileNumber(number){
    const mobileNumberRegex = /^05\d{8}$/;
    return mobileNumberRegex.test(number);
  };

 function validateResponse(response){
    return response?.payload?.Body?.header?.returnCode === '00';
  };

  function prepareSmsData(status, primaryContactPhone){
    if (status === kosherOrAflaloStatusTypes.BLOCK) {
      return {
        templateName: templateCodeTypes.VOUCHER_VOICE,
        isVoiceSms: true,
        primaryContactPhone: primaryContactPhone,
        couponType: couponType,
        voucherParamList: {
          voucherSerial: couponNumber ?? '',
          voucherExpDate: couponExpiryDate ?? '',
          voucherCode: couponType ?? '',
        },
      };
    } else {
      return {
        templateName: templateCodeTypes.VOUCHER_SMS,
        isVoiceSms: false,
        primaryContactPhone: primaryContactPhone,
        couponType: couponType,
        voucherParamList: {
          voucherText: smsText ?? '',
        },
      };
    }
  };

  async function handleResendSms(){
    try {
      if(!validateMobileNumber(primaryContactPhone)) {
       throw new Error('Invalid primary contact phone number');
      }
      const kosherOrAflaloNum = await getKosherOrAflaloStatus(primaryContactPhone);
      const isValidResponse = validateResponse(kosherOrAflaloNum);

      if (isValidResponse) {
        const status = kosherOrAflaloNum.payload.Body.body.response.status;
        const dataToSendFor499 = prepareSmsData(status, primaryContactPhone);
        const sendSmsReq = await sendCouponsSms(dataToSendFor499);

        handlePopup(sendSmsReq);
      } else {
        showErrorPopup();
      }
    } catch (error) {
      console.error('Error in handleResendSms:', error);
      showErrorPopup();
    }
  };

  function getLoginType({ isOtpAuthenticated, isFullAuthenticated, isOtpExtendedAuthenticated }){
    if (isOtpAuthenticated) return 'לקוח OTP';
    if (isFullAuthenticated) return 'לקוח בזיהוי מלא';
    if (isOtpExtendedAuthenticated) return 'לקוח OTP מורחב';
    return 'Unknown';
  };

  function getReportParamsObj({ contactNumber, firstName, lastName, IDNumber, IsContactPerson, IsPrimaryContact }){
    const loginType = getLoginType(loginData);
    return{
      contact: Boolean(IsContactPerson || IsPrimaryContact) ? 'איש קשר' : 'מנוי',
      loginType,
      sourceUrl: window.location.href,
      customerName: `${firstName} ${lastName}`,
      idNumber: IDNumber,
      subscriber: contactNumber,
    };
  };

  function handlePopup(sendSmsReq){
    const { to, status } = sendSmsReq.payload;
    setShowPopUp(true);

    if(validateMobileNumber(to)) {
      setSmsDestinationNumber(to);
    }
    const reportObj = getReportParamsObj(loginData?.userDetails, status);
    if(status) {
      setInnerPopupType(innerPopupTypes.SUCCESS)
      dwhResendCouponSuccessReport(reportObj);
    }
    else{
      setInnerPopupType(innerPopupTypes.ERROR);
      dwhResendCouponErrorReport(reportObj);
    }
  };

  function showErrorPopup(){
    setShowPopUp(true);
    setInnerPopupType(innerPopupTypes.ERROR);
  };

  function getSubsAsteriskReformPhone(){
    return `${smsDestinationNumber?.substring(7, 10)}****-***`;
  };

  function getPopupTextInSuccess(){
    if (smsDestinationNumber) {
      return `שלחנו את הקופון ב-SMS למס' ${getSubsAsteriskReformPhone()}`;
    }
    return "שלחנו את הקופון";
  };

  function renderingInnerPopup(){
    if (!innerPopupType || !showPopUp) {
      return null;
    }
    switch (innerPopupType) {
      case innerPopupTypes.SUCCESS: {
        return <InnerPopupComponent
                  image={thumbUp}
                  text={getPopupTextInSuccess()}
                  whiteBtnText='סיום'
                  setShowPopUp={setShowPopUp}
                  />;
      }
      default: {
        return (
          <InnerPopupComponent
            image={warningSign}
            text={`מצטערים משהו השתבש ולא ניתן לבצע את הפעולה שביקשת`}
            purpleBtnText='הבנתי, תודה'
            isErrorText={true}
            setShowPopUp={setShowPopUp}
          />
        );
      }
    }
  };

  function formatClientNameIfTooLong(clientName){
      return isClientNameTooLong ? clientName.slice(0, 13) + '...' : clientName;
  }

  const isActive = !isUsed && isCouponValid(couponExpiryDate);
  const rightCouponImageMobile = isActive  ? emptyCouponRightMobile : grayEmptyCouponRightMobile;
  const rightCouponImageDesktop = isActive ? emptyCouponRightDesktop : grayEmptyCouponRightDesktop;
  const leftCouponImageMobile = isActive ? emptyCouponLeftMobile : grayEmptyCouponLeftMobile;
  const leftCouponImageDesktop = isActive ? emptyCouponLeftDesktop : grayEmptyCouponLeftDesktop;

  const rightCouponImage = isMobile ? rightCouponImageMobile.bg() : rightCouponImageDesktop.bg();
  const leftCouponImage = isMobile ? leftCouponImageMobile.bg() : leftCouponImageDesktop.bg();

  return (
    <>
      <div className='coupon-wrapper'>
        <div className='right-container'>
          <div className="right-background-image" style={{ backgroundImage: rightCouponImage }} />
          <div className='right-body-container'>
            <div className='body-upper-area'>
              {couponDescription && (
                <div className='description'>
                  <span dangerouslySetInnerHTML={{__html: couponDescription}}></span>
                </div>
              )}
            </div>
            <div className='body-middle-area'>
              {couponNumber && <div className='coupon-number'>מס' קופון {couponNumber}</div>}
              <div className='client-name-and-number'>
                <div className='client-name'>
                  {formatClientNameIfTooLong(clientName)}
                  {isClientNameTooLong && <div className='display-full-name-in-asterisk-mode'>{clientName}</div>}
                </div>{' '}
                {clientPhone}
              </div>
              {!isUsed && couponExpiryDate && <div className='expiry-date'>בתוקף עד ה - {couponExpiryDate}</div>}
              {isUsed && useDate && <div className='expiry-date'>קופון מומש ב - {useDate}</div>}
            </div>
            <div className='body-lower-area'>
              {!isUsed && isCouponValid(couponExpiryDate) && (
                <div className='resend-sms'>
                  <span
                    onClick={async () => {
                      await handleResendSms();
                    }}>
                    לשליחה חוזרת בSMS
                  </span>
                </div>
              )}
              <div className='regulations'>
                <span onClick={() => buildUrlOpenPageSelfAndRestBlank(Config.epiBaseUrl + termsLink)}>לתקנון ההטבה</span>
              </div>
            </div>
          </div>
        </div>
        <div className='left-container'>
          <div className="left-background-image" style={{ backgroundImage: leftCouponImage }} />
          <div className='left-body-container'>
            {imageUrl && <Image className='image' src={Config.epiBaseUrl + imageUrl} />}
            {logoUrl && <Image className='logo' src={Config.epiBaseUrl + logoUrl} />}
          </div>
        </div>
        <PopUp showPopUp={showPopUp} onClose={() => setShowPopUp(false)}>
          {renderingInnerPopup()}
        </PopUp>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  loginData: state.authentication?.loginData,
});

const mapDispatchToProps = {
  sendCouponsSms,
  getKosherOrAflaloStatus
};

export default connect(mapStateToProps, mapDispatchToProps)(CouponComponentMain);
